import { useEffect, useState } from "react";

/**
 * Determines if the current device is considered mobile based on touch support and screen size.
 * @returns {boolean} True if the device has touch support and either width or height < 500px
 */
function checkIsMobileDevice(): boolean {
	return (
		("ontouchstart" in window && window.innerWidth < 500) ||
		("ontouchstart" in window && window.innerHeight < 500)
	);
}

/**
 * Custom hook to detect if the current device is a mobile device.
 * Updates the value when the window size changes (e.g., on browser resize).
 *
 * @returns {boolean} True if the device is considered mobile (has touch support and either width or height < 500px)
 */
export function useIsMobileDevice(): boolean {
	const [isMobileDevice, setIsMobileDevice] = useState(() => {
		// Initial check
		return checkIsMobileDevice();
	});

	useEffect(() => {
		const handleSizeChange = () => {
			setIsMobileDevice(checkIsMobileDevice());
		};

		// Listen for window resize events
		window.addEventListener("resize", handleSizeChange);

		// Cleanup event listeners on unmount
		return () => {
			window.removeEventListener("resize", handleSizeChange);
		};
	}, []);

	return isMobileDevice;
}
